import {
    ADD_DEREGISTRATION_DEVICE_ACTION,
    DELETE_DEREGISTRATION_DEVICE_ACTION,
    MODIFY_DEREGISTRATION_DEVICE_ACTION
} from "../../../actionType";

export default function (state=[],action){
    switch (action.type) {
        case ADD_DEREGISTRATION_DEVICE_ACTION:
            return [
                ...state,
                {
                    branchId:action.branchId,
                    branchCode: action.branchCode,
                    branchName: action.branchName,
                    effectiveDate:action.effectiveDate,
                    reason:action.reason,
                    component:action.component,
                    dsn:action.dsn,
                    operateType:action.operateType,
                    operatePeriod:action.operatePeriod,
                    key:action.key,
                }
            ];
        case MODIFY_DEREGISTRATION_DEVICE_ACTION:
            const deviceGridData = state;
            deviceGridData[action.index] = action.deviceInfo;
            return [
                ...deviceGridData,
            ];
        case DELETE_DEREGISTRATION_DEVICE_ACTION:
            state.splice(action.index,1);
            return [...state];
        default:
            return state;
    }
}